// Settings.jsx
import React, { useState, useContext, useEffect } from 'react';
import UserContext from '../context/UserContext';
import axios from '../api/client';

const LANGUAGE_OPTIONS = [
  { value: 'en', label: 'English' },
  { value: 'pl', label: 'Polski' },
  { value: 'de', label: 'Deutsch' },
  { value: 'es', label: 'Español' },
  // add more if you like
];

const Settings = () => {
  const { user, setUser, isLoggedIn } = useContext(UserContext);

  const [displayName, setDisplayName] = useState(user?.displayName || '');
  const [pronouns, setPronouns]       = useState(user?.pronouns || '');
  const [bio, setBio]                 = useState(user?.bio || '');
  const [image, setImage]             = useState(null);

  // NEW: language state (fallback to 'en' if undefined)
  const [language, setLanguage]       = useState(user?.language || 'en');

  const [saving, setSaving]           = useState(false);
  const [error, setError]             = useState('');
  const [saved, setSaved]             = useState('');

  useEffect(() => {
    setLanguage(user?.language || 'en');
  }, [user?.language]);

  // Existing account update with file upload (unchanged)
  const handleUpdateAccount = async () => {
    try {
      const formData = new FormData();
      formData.append('username', user.username);
      formData.append('displayName', displayName);
      formData.append('pronouns', pronouns);
      formData.append('bio', bio);
      if (image) formData.append('pfp', image);

      const response = await axios.post('https://stocksleuth.xyz:5000/auth/update', formData);
      setUser(response.data.updatedUser);
      window.location.reload();
    } catch (err) {
      console.error('Account update failed', err);
    }
  };

  // NEW: preferences updater (language now, more later)
  const handleApplyPreferences = async () => {
    try {
      setSaving(true);
      setError('');
      setSaved('');
      const payload = {
        language,
      };

      const resp = await axios.post('/auth/update-preferences', payload, {
        headers: { 'Content-Type': 'application/json' },
      });

      if (resp?.data?.updatedUser) {
        setUser((current) => ({ ...current, ...resp.data.updatedUser }));
        setSaved('Preferences saved.');
      }
    } catch (err) {
      console.error('Failed to apply preferences', err);
      setError('Failed to apply preferences.');
    } finally {
      setSaving(false);
    }
  };

  if (!isLoggedIn) return <div />;

  return (
    <div className="AccountPageShell" style={{ height: '100vh', width: '100vw', display: 'flex', alignItems: 'center',
                  justifyContent: 'center', textAlign: 'center', position: 'absolute', left: 0 }}>
      <div className="AccountForm">
        <div className="AccountHeading">Settings</div>

        {/* Language dropdown */}
        <div style={{ marginTop: 30, textAlign: 'left', width: '100%', paddingLeft: 30 }}>
          <label htmlFor="language" style={{ display: 'block', marginBottom: 8 }}>Language</label>
          <select
            id="language"
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
            style={{ padding: 8, minWidth: 200 }}
          >
            {LANGUAGE_OPTIONS.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
          <div style={{ marginTop: 8, color: '#888' }}>Current: {user?.language || 'en'}</div>
        </div>

        {/* Apply button */}
        <div style={{ marginTop: 20, textAlign: 'left', width: '100%', paddingLeft: 30 }}>
          <button
            onClick={handleApplyPreferences}
            disabled={saving}
            style={{ padding: '8px 14px', cursor: 'pointer' }}
          >
            {saving ? 'Applying…' : 'Apply changes'}
          </button>
          {error && <div style={{ color: 'crimson', marginTop: 8 }}>{error}</div>}
          {saved && <div role="status" style={{ color: '#16794b', marginTop: 8 }}>{saved}</div>}
        </div>

        {/* (Your existing account section / avatar / pronouns etc.) */}
        {/* <button onClick={handleUpdateAccount}>Update Account</button> */}
      </div>
    </div>
  );
};

export default Settings;
